import { Activity, Euro, FileText, Pill, Search, Wallet } from "lucide-react";

import { BarChartCard } from "./BarChartCard";
import { formatCount, formatCurrency } from "./chartPalette";
import { DonutChartCard } from "./DonutChartCard";
import { ChartsGrid, InsightsPanel, StatsRow } from "./InsightsLayout";
import { StatCard } from "./StatCard";
import { TrendChartCard } from "./TrendChartCard";

export const ConsultationsInsights = ({ insights, isLoading }) => {
  return (
    <InsightsPanel>
      <StatsRow>
        <StatCard label="Total Consultations" icon={Activity} isLoading={isLoading}
          value={formatCount(insights?.totalConsultations)} />
        <StatCard label="Total Billed" icon={Euro} isLoading={isLoading}
          value={formatCurrency(insights?.totalBilled)} />
        <StatCard label="Outstanding" icon={Wallet} tone="warning" isLoading={isLoading}
          value={formatCurrency(insights?.totalOutstanding)} />
        <StatCard label="Prescriptions Issued" icon={Pill} isLoading={isLoading}
          value={formatCount(insights?.prescriptionsIssuedCount)} />
        <StatCard label="Investigations" icon={Search} isLoading={isLoading}
          value={formatCount(insights?.investigationsCount)} />
        <StatCard label="Referrals" icon={FileText} isLoading={isLoading}
          value={formatCount(insights?.referralsCount)} />
      </StatsRow>
      <ChartsGrid>
        <DonutChartCard title="Consultations by Status" data={insights?.byStatus} isLoading={isLoading} />
        <BarChartCard title="Consultations by Doctor" data={insights?.byDoctor} isLoading={isLoading} />
        <TrendChartCard title="Consultations Over Time" data={insights?.trendByDay} isLoading={isLoading} />
      </ChartsGrid>
    </InsightsPanel>
  );
};
